import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

export const accidentStartWith = async (search) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicleAccidentView/namestartswith`,
      search,
    );
    return response.data.map((item) => ({
      key: item.id,
      title: item.text,
      value: item.value,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const AccedentById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/vehicleAccidentView/name/${id}`,
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};

export const updateBlackList = async (data) => {
  try {
    return await gatewayInstance.put(
      `${SERVICE_ENDPOINT.TRANSPORT}/blacklistCreation`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};

export const addBlackList = async (data) => {
  try {
    return await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/blacklistCreation`,
      data,
    );
  } catch (e) {
    console.error(e);
  }
};

export const searchBlackList = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/blacklist/search`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getBlackListById = async (id) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/blacklistCreation/${id}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getVehEmpByRefIdAndCateId = async (refId, catId) => {
  try {
    const response = await gatewayInstance.get(
      `${SERVICE_ENDPOINT.TRANSPORT}/blacklistCreation/${refId}/${catId}`,
    );
    return response.data.data[0];
  } catch (e) {
    console.error(e);
  }
};
